'use strict';

var u = require('yup');
var data = require('@valenzinsights/data');
var jwtDecode = require('jwt-decode');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n.default = e;
	return Object.freeze(n);
}

var u__namespace = /*#__PURE__*/_interopNamespace(u);

var f=t=>{try{JSON.parse(t);}catch{return !1}return !0},w=()=>{let t=sessionStorage.getItem("user");if(t&&f(t))return JSON.parse(t)},x=()=>{let t=document.cookie.split(";");for(let e=0;e<t.length;e++){let r=t[e],n=r.indexOf("="),o=n>-1?r.substring(0,n):r;document.cookie=o+"=;expires=Thu, 01 Jan 1970 00:00:00 GMT";}};function y(t){return new Promise((e,r)=>{let n=new FileReader;n.onload=()=>{e(n.result);},n.onerror=o=>r(o),n.readAsDataURL(t);})}var I=(t,e="thumbnail")=>{let r=t.split(","),n=r[0].match(/:(.*?);/);if(!n)throw new Error("Invalid base64 data");let o=n[1],d=o.split("/")[1],m=`${e}.${d}`,s=window.atob(r[1]),l=s.length,c=new Uint8Array(l);for(let a=0;a<l;a++)c[a]=s.charCodeAt(a);let p=new Blob([c],{type:o});return new File([p],m,{type:o})};function k(t,e,r){if(!t)return {isValid:!1,error:"File is required"};let n=t.name.split(".").pop()?.toLowerCase();return e.some(o=>o.toLowerCase()===n)?t.size>r?{isValid:!1,error:`File size should not exceed ${r/1024} KB.`}:{isValid:!0,error:null}:{isValid:!1,error:`Allowed formats are ${e.join(", ")}.`}}var T=(t,e)=>{try{return e&&e.validateSync(t),!0}catch{return !1}};function v(t){let e=u__namespace.string();return t&&t.forEach(r=>{switch(r.type){case data.ValidationType.IsRequired:r.value==!0&&(e=e.required(r.error??"This field is required"));break;case data.ValidationType.IsNumeric:e=e.matches(/^\d+$/,r.error??"Must be a number");break;case data.ValidationType.MinLength:e=e.min(Number(r.value),r.error??"More characters required");break;case data.ValidationType.MaxLength:e=e.max(Number(r.value),r.error??"Max characters exceeded");break;case data.ValidationType.IsEmail:e=e.matches(new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/),r.error??"Invalid Email");break;case data.ValidationType.Regex:r?.value&&typeof r?.value=="string"&&(e=e.matches(new RegExp(r?.value),r.error??"Invalid Email"));break;}}),e}var S=t=>{let e=null;try{e=jwtDecode.jwtDecode(t);}catch(r){console.error("Error decoding JWT token:",r);}return e},V=()=>{localStorage.clear();};

exports.a = f;
exports.b = w;
exports.c = x;
exports.d = y;
exports.e = I;
exports.f = k;
exports.g = T;
exports.h = v;
exports.i = S;
exports.j = V;
